module.exports = __webpack_public_path__ + "img/risk.32c293eb.png";